import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import { colorBlue, colorWhite, colorLightGray } from './colors';

const solidBorder = `1px solid ${colorLightGray}`;

export const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: '20px',
    width: 'inherit',
  },
  button: {
    '&:hover': {
      backgroundColor: '#0099CC',
      color: '#FFF',
    },
    backgroundColor: '#CED6DE',
    margin: theme.spacing(0.5, 0),
  },
  checkbox: {
    display: 'none',
    padding: '0 4px',
  },
  selected: {
    backgroundColor: colorBlue,
    color: colorWhite,
  },
  blue: {
    backgroundColor: 'unset',
  },
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#FFF',
    },
    backgroundColor: '#0099CC',
    borderBottom: 'none',
    borderTop: solidBorder,
    borderLeft: solidBorder,
    borderRight: solidBorder,
    borderRadius: '4px 4px 0px 0px',
    color: '#FFF',
    fontSize: '1.6em',
    width: '178px',
  },
  list: {
    backgroundColor: colorWhite,
    border: solidBorder,
    borderRadius: '4px 4px 0px 0px',
  },
}));

export const MultiSelectWrapper = styled.div`
  display: flex;
  alignItems: center;
`;
